import { useContext } from 'react'
import { ToastAPICtx } from './ToastAPICtx'

export const useToasts = () => useContext(ToastAPICtx)
